import { ThemeOptions, createTheme } from "@mui/material/styles";
import { grey, red, green } from "@mui/material/colors";
import { esES } from "@mui/x-date-pickers/locales";
const primaryColor = {
  main: "#e75f11",
  dark: "#bf370a",
  light: "#ffe4d4",
  contrastText: "#fff"
};
const secondaryColor = {
  main: "#728ba0",
  dark: "#54595e",
  light: "#abb5be",
  contrastText: "#fff"
};
let theme = createTheme({}, esES);
theme = createTheme(theme, ({
  typography: {
    fontFamily: ["Inter", "Roboto"].join(",")
  },
  palette: {
    primary: primaryColor,
    secondary: secondaryColor,
    success: {
      ...theme.palette.success,
      main: "#28A745",
      light: green[100],
      dark: green[300],
      contrastText: green[900]
    },
    error: {
      ...theme.palette,
      light: red[100],
      dark: red[900],
      contrastText: red[900]
    }
  }
} as ThemeOptions));
theme = createTheme(theme, ({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: grey[200]
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 16
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          "&.Mui-disabled": {
            backgroundColor: grey[200],
            "& input": {
              WebkitTextFillColor: grey[600]
            }
          }
        },
        input: {
          padding: "12px 14px"
        }
      }
    },
    MuiButton: {
      defaultProps: {
        variant: "contained",
        disableElevation: true
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "1rem",
          borderRadius: 6
        },
        containedError: {
          background: theme.palette.error.light,
          ":hover": {
            backgroundColor: theme.palette.error.main,
            color: "white"
          }
        },
        outlined: {
          border: "1.9px solid rgba(231, 95, 17, 1)",
          "&:hover": {
            backgroundColor: "rgba(231, 95, 17, 0.2)"
          }
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500
        },
        standardError: {
          border: `1px solid ${theme.palette.error.dark}`,
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark
        },
        standardSuccess: {
          border: `1px solid ${theme.palette.success.dark}`,
          backgroundColor: theme.palette.success.light
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        colorSuccess: {
          backgroundColor: theme.palette.success.light
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: grey[600]
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.main,
          fontSize: ".8rem",
          fontWeight: "bold",
          marginLeft: 5
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: grey[600],
          "&.Mui-selected": {
            backgroundColor: primaryColor.main,
            color: "white",
            "&:hover": {
              backgroundColor: primaryColor.main,
              color: "white"
            }
          }
        }
      }
    }
  }
} as ThemeOptions));
theme.shadows[10] = "0px 1px 4px 0px #0000001A";
theme.shadows[12] = "0px 4px 10px 0px #0000001F";
theme.shadows[16] = "0px 8px 35px 0px #00000029";
export default theme;